import { render, staticRenderFns } from "./businessAccounting.vue?vue&type=template&id=da4e6718"
import script from "./businessAccounting.vue?vue&type=script&lang=js"
export * from "./businessAccounting.vue?vue&type=script&lang=js"
import style0 from "./businessAccounting.vue?vue&type=style&index=0&id=da4e6718&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports